module.exports = __webpack_public_path__ + "static/media/Stantler_gaussian2.3196c229.png";